function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 31 27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19.34 4.064v19.36a.5.5 0 01-.753.43l-8.013-4.685a2.5 2.5 0 00-1.262-.342H4.395a2.5 2.5 0 01-2.5-2.5v-2.71h0v-2.55a2.5 2.5 0 012.545-2.5l4.835.088a2.5 2.5 0 001.307-.341l8.005-4.681a.5.5 0 01.753.431z",
  stroke: "#FDD113",
  strokeWidth: "3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.438 7.249c2.505 5.652 2.37 8.618 0 13.648",
  stroke: "#FDD113",
  strokeWidth: "3",
  strokeLinecap: "round"
})));